import { render, staticRenderFns } from "./GiveGift.vue?vue&type=template&id=6f289474&scoped=true"
import script from "./GiveGift.vue?vue&type=script&lang=js"
export * from "./GiveGift.vue?vue&type=script&lang=js"
import style0 from "./GiveGift.vue?vue&type=style&index=0&id=6f289474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f289474",
  null
  
)

export default component.exports